import { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import { BzDropdown, BzModal, BzModalBody, BzModalHeader } from '../../components';
import { getHistoricChartData } from '../../apis/nontransactional';
import { useDispatch, useSelector } from 'react-redux';
import { convertHistoricData, getNormalisation } from '../../controllers/analysis';
import { LOCAL_STORAGE_KEYS, analysisIndices, historicYears } from '../../utils/global_variables';
import AnalysisDonutChart from './AnalysisDonutChart';
import { deepClone, getApiExchangeNameFromMktSegId, getDecryptLocalStorage } from '../../utils/global_functions';
import ZeroStates from '../ZeroStates';
import { handleModal } from '../../redux/actions/modals';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
// import LineChart from '../Portfolio/AnalysisLine';
import AnalysisLine from './AnalysisLine';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const BenchmarkPerformanceInfoModal = () => {
    const modals = useSelector(state => state.modals.modals);
    const dispatch = useDispatch();
    const handleExitBenchmarkPerformanceModal = () => {
        dispatch(handleModal([{ "BENCHMARK_PERFORMANCE_INFO_MODAL": false }]))
    }
    return (

        <BzModal size="md" show={modals["BENCHMARK_PERFORMANCE_INFO_MODAL"]} onHide={handleExitBenchmarkPerformanceModal}>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>Benchmark Performance</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleExitBenchmarkPerformanceModal}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-start'>
                            <div className='font-regular font-size4 color-text'>
                                <div>
                                    The Portfolio Benchmark feature is designed to provide investors with an approximation of how their holdings is performing compared to the selected index benchmark. Please note that this comparison is based solely on the current quantity of holdings and does not consider the actual quantity bought and sold over time.
                                </div>
                                <br />
                                <div>
                                    For instance, if you had previously bought and sold shares of Stock A multiple times, only the current number of shares you hold is reflected in this comparison, not the cumulative transaction history.
                                </div>
                                <br />
                                <div>
                                    Example
                                </div>
                                <br />
                                <ul>
                                    User A currently has 1000 Shares of ACC. Their previous trades in ACC are as following:
                                    <li>Bought 750 shares @2010 on 8th Jan 2024.  Total shares in DP: 750</li>
                                    <li>Bought 850 shares @2150 on 15th Jan 2024. Total shares in DP: 1600</li>
                                    <li>Sold 600 Share @2790 on 25th Jul 2024. Total shares in DP: 1000</li>
                                </ul>
                                <br />
                                <div>
                                    Portfolio benchmark will consider current holding Qty i.e., 1000 Qty for the entire calculation of performance from Day 1 of the comparison. Therefore, the graph is an approximation and may not represent the precise performance of your investment decision.
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
        </BzModal>
    )
}


const Analysis = ({ arrGridRowData, objPortfolioSumaary, areaChartConfig }) => {
    const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
    const [indiceData, setIndiceData] = useState([]);
    const [portfolioData, setPortfolioData] = useState(false);
    const [yearCount, setYearCount] = useState(null);
    const [option, setOption] = useState(null);
    const [optiontext, setOptiontext] = useState('');
    const [yeartext, setYeartext] = useState('');
    const [objStocksData, setObjStocksData] = useState({});
    const dispatch = useDispatch();
    const strActiveTheme = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.THEME);

    function normalizePercentages(arr, key) {
        const total = arr.reduce((sum, item) => sum + item[key], 0);
        if (total === 0) return arr;

        let runningTotal = 0;
        return arr.map((item, idx) => {
            let normalizedValue;
            if (idx === arr.length - 1) {
                // Make last one equal to remaining to total exactly 100
                normalizedValue = parseFloat((100 - runningTotal).toFixed(2));
            } else {
                normalizedValue = parseFloat(((item[key] / total) * 100).toFixed(2));
                runningTotal += normalizedValue;
            }
            return { ...item, [key]: normalizedValue };
        });
    }

    //Ameersha N : BT-119455: 04-06-24: Portfolio analysis -- Start
    const { sectorData, stockData } = useMemo(() => {
        let sectorData = [];
        let stockData = [];
        let result = {};
        // Vinit R : BT-119455: 16-07-24: Portfolio analysis -- Start
        // let arrEquitiesScrips = arrGridRowData?.filter(eachScip => eachScip?.ScripData[0]?.sInstrumentName === "EQUITIES");
        let arrEquitiesScrips = [];
        arrGridRowData?.forEach(eachScip => {
            if (eachScip?.ScripData?.length > 0 && eachScip?.ScripData[0]?.sInstrumentName === 'EQUITIES') {
                arrEquitiesScrips.push(eachScip);
            }
        });
        // Vinit R : BT-119455: 16-07-24: Portfolio analysis -- End
        const arreqScripsCopy = deepClone(arrEquitiesScrips);

        if (arreqScripsCopy?.length > 0) {
            arreqScripsCopy?.forEach((eachScrip) => {
                const strSector = eachScrip?.ScripData[0]?.sSector;
                const unconvertedPrice = eachScrip?.nBuyAvgPrice
                const stockPrice = parseFloat(unconvertedPrice);
                if (!result[strSector]) {
                    result[strSector] = { totalValue: (stockPrice * eachScrip?.qty), count: 1 };
                } else {

                    result[strSector].count += 1;
                    result[strSector].totalValue += (stockPrice * eachScrip?.qty);

                }
            });
        }

        if (arrEquitiesScrips?.length > 0) {
            arrEquitiesScrips?.forEach((eachScrip) => {


                let nIndex = sectorData?.findIndex((scrip) => scrip?.sector?.toLowerCase() === eachScrip?.ScripData[0]?.sSector?.toLowerCase());
                if (nIndex < 0) {
                    let obj = { sector: eachScrip?.ScripData[0]?.sSector, index: sectorData?.length + 1, value: result[eachScrip?.ScripData[0]?.sSector].totalValue, sectorPercentage: (result[eachScrip?.ScripData[0]?.sSector].totalValue / Number(objPortfolioSumaary?.currentValue)) * 100 };
                    sectorData?.push(obj); // we are pushing for the single sector we found
                }
                setObjStocksData(result);
            });
        }
        sectorData?.forEach(eachSector => {
            let arrSectorWiseFilteredata = arrEquitiesScrips?.filter(eachScrip => eachScrip?.ScripData[0]?.sSector === eachSector?.sector);
            if (arrSectorWiseFilteredata?.length > 0) {
                arrSectorWiseFilteredata?.forEach(eachScrip => {
                    let aindex = stockData?.findIndex(eachScripItem => eachScripItem?.stock === eachScrip?.ScripData[0]?.sSymbol && eachScripItem?.sector === eachScrip?.ScripData[0]?.sSector);
                    if (aindex < 0) {

                        const unconvertedPrice = eachScrip?.nBuyAvgPrice 
                        const stockPrice = parseFloat(unconvertedPrice);
                        stockData?.push({ stock: eachScrip?.ScripData[0]?.sSymbol, value: (stockPrice * eachScrip?.qty), sector: eachScrip?.ScripData[0]?.sSector, percentage: ((stockPrice * eachScrip?.qty) / Number(objPortfolioSumaary?.currentValue)) * 100 });
                    }
                });
            }
        });
        // Normalize percentages
        sectorData = normalizePercentages(sectorData, 'sectorPercentage');
        stockData = normalizePercentages(stockData, 'percentage');
        return { sectorData, stockData };
    }, [arrGridRowData, objPortfolioSumaary?.currentValue]);
    //Ameersha N : BT-119455: 04-06-24: Portfolio analysis -- End

    const callPortfolioApi = useCallback(async () => {
        let allData = [];
        // ---BT-119455_SrikanthRao_12-04-2024_ Portfolio - Analysis || API Implementation For Single/Multiple Scrip in getHistoricChartData - START
        if (holdingsScrips?.length) {
            let arrPlayload = holdingsScrips?.map(eachHolding => ({
                "MktSegId": eachHolding?.nMarketSegmentId,
                "Token": eachHolding?.nToken,
                "Records": yearCount * 12,
                "Exchange": getApiExchangeNameFromMktSegId(eachHolding?.nMarketSegmentId),
                "TimeInterval": 2,
                // "LastUpdateDatetime": 976060800,{TimeInterval = 0-Daily,1-Weekly,2-Monthly ,3-Quarter ,4-Yearly // optional key to be sent if required} for future referance
            }));
            let temp = await getHistoricChartData({
                "scrip_info": arrPlayload
            });
            if (temp.data?.result?.length > 0) {
                temp.data?.result?.forEach((eachResult, index) => {
                    if (eachResult?.length > 0) {
                        allData.push(...convertHistoricData(eachResult, holdingsScrips[index]?.TOTALFREEQUANTITY));
                    }
                });
            }
            // ---BT-119455_SrikanthRao_12-04-2024_ Portfolio - Analysis || API Implementation For Single/Multiple Scrip in getHistoricChartData - End
            if (allData?.length) {
                let arr2 = [];
                allData.forEach((y, i) => {
                    if (arr2.filter(w => w.date === y.date).length === 1) return;
                    let arr = allData.filter(x => x.date === y.date);
                    let finQty = 0;
                    let finClose = 0;
                    arr.forEach((z, i) => {
                        let prevC = parseFloat(z.close);
                        let prevQty = parseInt(z.qty);
                        finQty = parseInt(finQty) + parseInt(prevQty);
                        finClose = finClose + prevC;
                    });
                    arr2.push({ ...y, finQty, finClose: parseFloat(finClose.toFixed(2)) });
                });
                let arrNormalizedPortfolioData = getNormalisation(arr2, "portfolio");
                let combinedChartData
                if (indiceData?.length) {
                     combinedChartData = indiceData?.map(data => {
                         let normalizedData = arrNormalizedPortfolioData?.find(x => data.ltt === x.ltt);
                        if (normalizedData) {
                            return { ...data, ...normalizedData };
                        }
                        return { ...data };
                    });
                } else {
                    combinedChartData = arrNormalizedPortfolioData
                }
                setPortfolioData(false)
                setIndiceData(combinedChartData);
            }
        }
    }, [holdingsScrips, indiceData, yearCount]);
    

    const callApi = useCallback(async () => {
        let updatedRecords = parseInt(yearCount) * 12;
        let temp = await getHistoricChartData({
            MktSegId: parseInt(option.split('_')[0]),
            Token: parseInt(option.split('_')[1]),
            Records: updatedRecords,
            TimeInterval: 2,

        });
        if (temp.data.result[0].length > 0) {
            let normalizedData = getNormalisation(convertHistoricData(temp?.data?.result[0]), 'indice')
            setIndiceData(normalizedData);
            setPortfolioData(true)
        } else {
            let normalizedData = getNormalisation(convertHistoricData([]), 'indice')
            setIndiceData(normalizedData);
            setPortfolioData(true)
        }
    }, [option, yearCount]);

    useEffect(() => {
        if (!option && !yearCount) {
            setOption(analysisIndices[0]?.id);
            setYearCount(historicYears[0]?.id);
        }
    }, [option, yearCount]);

    useEffect(() => {
        if (option && yearCount)
            callApi();
    }, [callApi, option, yearCount]);

    useEffect(() => {
        if (portfolioData && yearCount) {
            callPortfolioApi();
        }
    }, [callPortfolioApi, holdingsScrips, portfolioData, yearCount]);

    const triggerBenchmarkPerformanceInfoModal = () => {
        dispatch(handleModal([{ "BENCHMARK_PERFORMANCE_INFO_MODAL": true }]))
    }

    // Hari:04-10-2024: setting canvas height and width dynamically on chages on window size-start
    useEffect(() => {
        // const handleResize = () => {
        const canvas = document.querySelector('#chart-canvas')
        if (canvas) {
            canvas.style.height = '760px'
            // canvas.style.width = `${window.outerWidth}px`
        } else { }

        // }
        // window.addEventListener('resize', handleResize)
    }, [])
    // Hari:04-10-2024: setting canvas height and width dynamically on chages on window size-end

    const [showNormInd, setShowNormInd] = useState(true);
    const [showCloseInd, setShowCloseInd] = useState(true);
    const hasNormPort = useMemo(() => {
        return indiceData?.some(obj => 'normPort' in obj);
    }, [indiceData]);
   
    return (
        <div className='portfolio-analysistabs-scroll pe-2'>
            <Container data-testid="portfolio-analysis-sector-allocation-container" fluid className='p-0 mt-3'>
                <div className='scripoverview-fieldset'>
                    <div className='scripoverview-legend'>SECTOR ALLOCATION</div>
                    <Row className='g-0 mt-3'>
                        <Col className='d-flex justify-content-center align-items-center'>
                            {/* ManasaB : 04-11-2024 : Chartjs changes - Start */}
                            <div data-testid="portfolio-analysis-sector-pie-chart" className='d-flex justify-content-center align-items-center'>
                                {/* ManasaB : 04-11-2024 : Chartjs changes - End */}
                                {arrGridRowData?.length > 0 ?
                                    <AnalysisDonutChart sectorData={sectorData} stockData={stockData} /> :
                                    <div className='zero-state-alerts zero-state-alerts-xl'>
                                        <ZeroStates subText="No Data to Display" />
                                    </div>}
                            </div>
                        </Col>
                    </Row>
                </div>

                <div data-testid="portfolio-analysis-benchmark-performance-container" className='scripoverview-fieldset mt-3'>
                    <div className='scripoverview-legend'>BENCHMARK PERFORMANCE<span className='icon-16 icon-info icon-dark ms-2' onClick={triggerBenchmarkPerformanceInfoModal}></span></div>
                    {hasNormPort ?
                        <div data-testid="portfolio-analysis-benchmark-performance-chart">
                            <Row className='g-0 mb-2 align-items-center justify-content-between'>
                                <Col md="auto" className="d-flex align-items-center">
                                <div className='d-flex gap-2 align-items-center'>
                                    <div className={`d-flex align-items-center ${!showNormInd ? 'text-opacity':''}`} onClick={() => setShowNormInd(prev => !prev)}>
                                        <span className='benchmark-allocation-dot-blue'></span>
                                        <span className='font-regular font-size2 color-text line-height-1 cursor-pointer'>PORTFOLIO</span>
                                    </div>
                                    <div className={`d-flex align-items-center ${ ! showCloseInd ? 'text-opacity':''}`} onClick={() => setShowCloseInd(prev => !prev)}>
                                        <span className='benchmark-allocation-dot-yellow'></span>
                                        <span className='font-regular font-size2 color-text line-height-1 cursor-pointer'>{optiontext || analysisIndices?.[0]?.value}</span>
                                    </div>
                                </div>
                                </Col>
                                <Col className='justify-content-end text-end'>
                                    <div className='font-medium font-size2 color-text my-2 text-uppercase'>COMPARE WITH:</div>
                                </Col>
                                <Col md={2} className='justify-content-end text-end'>
                                    <div className='Bzmodalselect-dropdown ms-3'>
                                        <BzDropdown>
                                            <Dropdown.Toggle className='btn-default'>{optiontext || analysisIndices?.[0]?.value}</Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {analysisIndices?.map(data => {
                                                    return <Dropdown.Item onClick={(e) => {
                                                        setOption(data?.id);
                                                        setOptiontext(data?.value);
                                                    }
                                                    }>
                                                        {data?.value}
                                                    </Dropdown.Item>;
                                                })}
                                            </Dropdown.Menu>
                                        </BzDropdown>
                                    </div>
                                </Col>
                                <Col md={2} className='justify-content-end text-end ms-2'>
                                    <div className='Bzmodalselect-dropdown ms-3'>
                                        <BzDropdown>
                                            <Dropdown.Toggle className='btn-default'>{yeartext || historicYears?.[0]?.value}</Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                {historicYears?.map(yr => {
                                                    return <Dropdown.Item onClick={(e) => {
                                                        setYearCount(parseInt(yr?.id));
                                                        setYeartext(yr?.value);
                                                    }}>
                                                        {yr?.value}
                                                    </Dropdown.Item>;
                                                })}
                                            </Dropdown.Menu>
                                        </BzDropdown>
                                    </div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col>
                                    <AnalysisLine className='scripoverview-chart' lineData={indiceData} showCloseInd={showCloseInd} setShowCloseInd={setShowCloseInd} showNormInd={showNormInd} setShowNormInd={setShowNormInd} indice={optiontext || analysisIndices?.[0]?.value} selectedYear={yeartext} />
                                </Col>
                            </Row>
                            <Row className='g-0 my-2'>
                                <Col className='d-flex justify-content-center'>
                                    <div className='font-regular font-size1 color-subtext text-center'>The portfolio performance is calculated based on current portfolio holding numbers and does not account for historical transactions in the porfolio.</div>
                                </Col>
                            </Row>
                        </div>
                        : <div data-testid="portfolio-analysis-benchmark-chart-no-data"className='zero-state-alerts zero-state-alerts-xl'>
                            <ZeroStates subText="No Data to Display" />
                        </div>}
                </div>

                <BenchmarkPerformanceInfoModal />
            </Container>
        </div>
    );
};

export default memo(Analysis);